import defaultClient from '@src/api/clients/default';

// Ad-account card vault (apps.card_vault). The client-facing calls never
// return the card itself — only brand/last4/status. Reveal is staff-only and
// audited server-side.
const BASE = 'card-vault/';

export const fetchAdAccountCard = (clientSlug) =>
  defaultClient.request({ url: `${BASE}clients/${clientSlug}/card/` });

export const submitAdAccountCard = (clientSlug, payload) =>
  defaultClient.request({ url: `${BASE}clients/${clientSlug}/card/`, method: 'POST', payload });

export const withdrawAdAccountCard = (clientSlug) =>
  defaultClient.request({ url: `${BASE}clients/${clientSlug}/card/`, method: 'DELETE' });

export const requestAdAccountCard = (clientSlug) =>
  defaultClient.request({ url: `${BASE}clients/${clientSlug}/request/`, method: 'POST' });

export const revealAdAccountCard = (submissionId) =>
  defaultClient.request({ url: `${BASE}submissions/${submissionId}/reveal/`, method: 'POST' });

export const markAdAccountCardApplied = (submissionId) =>
  defaultClient.request({ url: `${BASE}submissions/${submissionId}/mark-applied/`, method: 'POST' });

export const discardAdAccountCard = (submissionId, reason = '') =>
  defaultClient.request({
    url: `${BASE}submissions/${submissionId}/discard/`,
    method: 'POST',
    payload: { reason },
  });

// My Invoices: the Facebook card status for each client-funded client I can see.
export const fetchMyAdAccountCards = () => defaultClient.request({ url: `${BASE}mine/` });

// Staff: cards waiting to be added + requests the client hasn't answered.
export const fetchAdAccountCardQueue = () => defaultClient.request({ url: `${BASE}queue/` });

export default {
  fetchMyAdAccountCards,
  fetchAdAccountCardQueue,
  fetchAdAccountCard,
  submitAdAccountCard,
  withdrawAdAccountCard,
  requestAdAccountCard,
  revealAdAccountCard,
  markAdAccountCardApplied,
  discardAdAccountCard,
};
